import { render, staticRenderFns } from "./Game5-7.vue?vue&type=template&id=c0cd21a6&scoped=true&"
import script from "./Game5-7.vue?vue&type=script&lang=js&"
export * from "./Game5-7.vue?vue&type=script&lang=js&"
import style0 from "./Game5-7.vue?vue&type=style&index=0&id=c0cd21a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cd21a6",
  null
  
)

export default component.exports